import { render } from "./Page.vue?vue&type=template&id=0c00777c&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=0c00777c&scoped=true&lang=css"

import exportComponent from "/Users/sebi/www/screen-app/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c00777c"]])

export default __exports__